/**
 * Idempotency key generation for mutating requests that must not be applied
 * twice (e.g. PO receive: a re-submitted request after a lost response would
 * otherwise double-adjust Shopify inventory).
 *
 * One key identifies one user intent. Mint it when the intent is confirmed,
 * reuse it across error retries of the same intent, and discard it once the
 * server acknowledges success. Backend column is VARCHAR(64).
 */
export function generateIdempotencyKey(): string {
  // Modern browsers (secure contexts)
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback: RFC4122-v4-shaped key via Math.random (no security requirement
  // here — the key only needs to be unique per merchant per receive intent)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
